// This may move to a specific workspace package, `env`, to create one
// central env schema and parsing function.

import { env } from '@auth/env';
import { parseEnv } from '@src/utils/env/parseEnv';
import { z } from 'zod';

const auth0EnvSchema = z.object({
  VITE_AUTH0_EU_DOMAIN: z.string(),
  VITE_AUTH0_US_DOMAIN: z.string(),
  VITE_AUTH0_EU_CLIENT_ID: z.string(),
  VITE_AUTH0_US_CLIENT_ID: z.string(),
  VITE_WEBAPI_AUTH0_EU_AUDIENCE: z.string(),
  VITE_WEBAPI_AUTH0_US_AUDIENCE: z.string(),
});

export const authEnv = parseEnv(env, auth0EnvSchema);
